<template>
  <q-dialog
      ref="dialog"
      class="dialog"
  >
    <q-card>
      <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
        <div class="heading-3 q-mr-sm">Contactgegevens</div>
        <q-space />
        <icon-button v-if="!persistent" icon="close" aria-label="Sluit dialoogvenster" size="sm" round v-close-popup />
      </q-card-section>
      <q-card-section class="dialog__messages" :class="$isMobile ? 'q-pb-none' : 'q-pt-none q-px-lg q-pb-sm'">
        <div v-if="details">
          <strong>E-mailadres:</strong>
          <div>{{ details.email }}</div>
          <template v-if="details.phone">
            <strong>Telefoonnummer</strong>
            <div>{{ details.phone }}:</div>
          </template>
        </div>
        <LoadingIndicator v-else />
      </q-card-section>
      <q-separator />
      <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
        <accent-button
            label="Sluiten"
            @click="hide"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    userId: {
      type: Number,
    },
  },
  data: () => ({
    details: null,
  }),
  methods: {
    show () {
      this.$refs.dialog.show()
      if (!this.details) {
        this.loadDetails()
      }
    },
    hide () {
      this.$refs.dialog.hide()
    },
    async loadDetails () {
      const response = await axios.get(this.$route('api.user.details', this.userId))
      console.log({ response })
      this.details = response.data
    },
  },
}
</script>
